import { render, staticRenderFns } from "./MenuPanel.vue?vue&type=template&id=c5d854e0"
import script from "./MenuPanel.vue?vue&type=script&lang=js"
export * from "./MenuPanel.vue?vue&type=script&lang=js"
import style0 from "./MenuPanel.vue?vue&type=style&index=0&id=c5d854e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports